import React from 'react'
import { Container, Box } from '@mui/material'
import Footer from './Footer'
import Header from './Header'


export default function ArticleWrap ({ children, title }) {
  return (
    <>
      <Header />
      <Box sx={{
        pt: { xs: 10, md: 25 },
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        bgcolor: 'wrapper.main',
        color: 'wrapper.contrastText'
      }}>
        <Container maxWidth='lg' component='main' sx={{ mb: 4 }}>
          <Box sx={{ color: '#fff', fontSize: { xs: 40, md: 55 }, fontWeight: 900, margin: '0 0 25px 0', padding: 0 }}>
            {title}
          </Box>
          {children}
        </Container>
        <Footer />
      </Box>
    </>
  )
}
